import React, { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { ERoutes } from '../../enums';
import { ButtonBase, Grid2, Typography } from '@mui/material';
import theme, { TMaterialStyles } from '../../theme';
import { useTranslation } from 'react-i18next';
import { Icon } from '../Icon';

export const NavBar: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onPlayPress = useCallback(
    () => navigate(ERoutes.gameModes),
    [navigate],
  );

  const onLeaderBoardPress = useCallback(
    () => navigate(ERoutes.leaderboard),
    [navigate],
  );

  const onUserProfilePress = useCallback(
    () => navigate(ERoutes.userProfile),
    [navigate],
  );

  const onReferralsPress = useCallback(
    () => navigate(ERoutes.referral),
    [navigate],
  );

  const onQuestsPress = useCallback(
    () => navigate(ERoutes.dailyQuests),
    [navigate],
  );

  return (
    <Grid2 sx={materialStyles.navBarContainer}>
      <Grid2 sx={materialStyles.navContainer}>
        <ButtonBase
          sx={materialStyles.navBarButtonContainer}
          onClick={onUserProfilePress}
        >
          <Icon sx={materialStyles.navBarIcon} iconName="ProfileIcon" />
          <Typography sx={materialStyles.navBarButtonTitle}>
            {t('nav_bar.profile')}
          </Typography>
        </ButtonBase>
      </Grid2>
      <Grid2 sx={materialStyles.navContainer}>
        <ButtonBase
          sx={materialStyles.navBarButtonContainer}
          onClick={onLeaderBoardPress}
        >
          <Icon sx={materialStyles.navBarIcon} iconName="LeadersIcon" />
          <Typography sx={materialStyles.navBarButtonTitle}>
            {t('nav_bar.leaders')}
          </Typography>
        </ButtonBase>
      </Grid2>
      <Grid2 sx={materialStyles.navContainer}>
        <ButtonBase
          sx={materialStyles.navBarButtonContainer}
          onClick={onPlayPress}
        >
          <Icon sx={materialStyles.playIcon} iconName="PlayIcon" />
          <Typography sx={materialStyles.navBarButtonTitle}>
            {t('common.play')}
          </Typography>
        </ButtonBase>
      </Grid2>
      <Grid2 sx={materialStyles.navContainer}>
        <ButtonBase
          sx={materialStyles.navBarButtonContainer}
          onClick={onReferralsPress}
        >
          <Icon sx={materialStyles.navBarIcon} iconName="FriendsIcon" />
          <Typography sx={materialStyles.navBarButtonTitle}>
            {t('nav_bar.friends')}
          </Typography>
        </ButtonBase>
      </Grid2>
      <Grid2 sx={materialStyles.navContainer}>
        <ButtonBase
          sx={materialStyles.navBarButtonContainer}
          onClick={onQuestsPress}
        >
          <Icon sx={materialStyles.navBarIcon} iconName="QuestsIcon" />
          <Typography sx={materialStyles.navBarButtonTitle}>
            {t('nav_bar.quests')}
          </Typography>
        </ButtonBase>
      </Grid2>
    </Grid2>
  );
};

const materialStyles: TMaterialStyles = {
  navBarContainer: {
    position: 'fixed',
    width: '100%',
    bottom: 0,
    px: '14px',
    pt: '14px',
    pb: '24px',
    justifyContent: 'flex-end',
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: theme.palette.primary.main,
    borderTopRightRadius: '14px',
    borderTopLeftRadius: '14px',
    boxShadow: `0px -4px 0px ${theme.palette.primary.dark}`,
    alignItems: 'end',
    zIndex: 100,
  },
  navContainer: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  navBarButtonContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  navBarIcon: {
    width: '25px',
    height: '25px',
  },
  playIcon: {
    width: '70px',
    height: '70px',
    marginTop: '-45px',
  },
  navBarButtonTitle: {
    marginTop: '6px',
    fontSize: '12px',
    lineHeight: '14px',
    fontWeight: '600',
  },
};
